// This file is used by WebPack to bundle the modular OpenLayers library to be able to use it in the (not recommended) global scope
// This solution was chosen instead of adding the dist manually in order to retain version control and types from npm

import * as ol from "ol"
import * as olProj from "ol/proj";
import * as olSource from "ol/source"
import * as olLayer from "ol/layer"
import * as olStyle from "ol/style"
import * as olGeom from "ol/geom"
import * as olControl from "ol/control"
import * as olExtent from "ol/extent"
import * as olCoordinate from "ol/coordinate"
import * as olFormat from "ol/format";
//import * as olPolygon from "ol/polygon";
//import * as olLineString from "ol/linestring";
import * as olColor from "ol/color";
import LayerSwitcher from 'ol-layerswitcher';

// After adding any part of OL here, WebPack needs to be run via Task Runner (custom -> build) and types need to be added in Scripts/typings/olTypeFix.d.ts
window.ol = ol;
window.ol.proj = olProj;
window.ol.source = olSource;    
window.ol.layer = olLayer;
window.ol.geom = olGeom;
window.ol.style = olStyle;
window.ol.control = olControl;
window.ol.extent = olExtent;
window.ol.coordinate = olCoordinate;
window.ol.format = olFormat;
//window.ol.polygon = olPolygon;
//window.ol.linestring = olLineString;
window.ol.color = olColor;
window.ol.layerSwitcher = LayerSwitcher;